import React from 'react';
import { styled } from '@mui/material/styles';

type TProps = {
  user: string;
  dateTime: string;
};

export const UserDate: React.FC<TProps> = ({ user, dateTime }) => {
  return (
    <>
      <UserContainer>{user}</UserContainer>
      <DateContainer>{dateTime}</DateContainer>
    </>
  );
};

const UserContainer = styled('div')({
  width: '50%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
  marginLeft: 15,
  marginRight: 15,
  borderRight: '1px #CCCCCC solid'
});

const DateContainer = styled('div')({
  width: '50%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
  marginLeft: 15,
  marginRight: 15
});
